"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyPriceWebSocket = void 0;
const BaseWebSocket_1 = require("./BaseWebSocket");
class CurrencyPriceWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.priceCache = new Map();
        // public getCurrencyPriceObservable(sendParam: any): Observable<Map<string, ExchangeTicker>> {
        //     return this.getMulticastSubject(SubscribeEventType.currencyPrice, sendParam, WebSocketPattern.patternSingle)
        //         .pipe(map(pushData => {
        //             const data = pushData.map(tickerInfo => ({
        //                 exchange: tickerInfo.market,
        //                 full_name: tickerInfo.full_name,
        //                 symbol: tickerInfo.base + "/" + tickerInfo.quote,
        //                 base: tickerInfo.base,
        //                 quote: tickerInfo.quote,
        //                 latest: tickerInfo.price,
        //                 fiat: 0,
        //                 latestAmount: 0,
        //                 changePercent: tickerInfo.change_percent,
        //                 prev24HPrice: tickerInfo.price - tickerInfo.change_percent * tickerInfo.price,
        //                 high: 0,
        //                 low: 0,
        //                 baseVol: 0,
        //                 quoteVol: 0
        //             } as ExchangeTicker));
        //             data.forEach(ticker => {
        //                 this.priceCache.set(ticker.symbol, ticker);
        //             });
        //
        //             return this.priceCache;
        //         }))
        //         .pipe(throttleTime(5000));
        // }
    }
    handleCurrencyPriceData(data) {
    }
}
exports.CurrencyPriceWebSocket = CurrencyPriceWebSocket;
